import Button from "ds/components/Button";
import { isSelfHostedDistribution } from "utils/distribution";

import { openSetUpDrawer } from "./SetUp";
import useConnectSlackIntegration from "./useConnectSlackIntegration";

const isSelfHosted = isSelfHostedDistribution();

type SettingsIntegrationsSlackConnectButtonProps = {
  hasIntegration: boolean;
  hasAppConfig?: boolean;
};

const SettingsIntegrationsSlackConnectButton = ({
  hasIntegration,
  hasAppConfig,
}: SettingsIntegrationsSlackConnectButtonProps) => {
  const { connectSlackIntegration, loading } = useConnectSlackIntegration();

  const handleSetUpSlackAppForSH = () => {
    openSetUpDrawer();
  };

  if (isSelfHosted) {
    if (!hasAppConfig && !hasIntegration)
      return (
        <Button variant="primary" onPress={handleSetUpSlackAppForSH}>
          Set up
        </Button>
      );

    if (hasAppConfig && !hasIntegration)
      return (
        <Button variant="primary" onPress={connectSlackIntegration} loading={loading}>
          Connect
        </Button>
      );

    return null;
  } else {
    if (!hasIntegration)
      return (
        <Button variant="primary" onPress={connectSlackIntegration} loading={loading}>
          Connect
        </Button>
      );

    return null;
  }
};

export default SettingsIntegrationsSlackConnectButton;
